<div
  class="grid grid-rows-[auto_1fr_auto] md:grid-rows-[auto_auto_1fr_auto] min-h-full max-h-full"
>
  <div
    class="soft-page-header-base"
    [ngClass]="[
      !header()?.template() && menu.menuItems().length === 0 ? '!hidden' : '',
      header()?.customClass() ?? '',
    ]"
  >
    <header
      class="grid grid-cols-[1fr_auto]"
      [ngClass]="(menu.menuItems() && menu.menuItems().length > 0) ? 'gap-0 md:gap-4' : ''"
    >
      <div class="flex flex-grow overflow-x-auto">
        <ng-container *ngTemplateOutlet="header()?.template() ?? null"></ng-container>
      </div>
      <soft-menu-outlet
        name="responsive"
        class="!hidden md:!flex flex-row !w-auto flex-nowrap shrink-0 justify-end items-center top-responsive-menu"
        #menu
      ></soft-menu-outlet>
    </header>
  </div>

  <nav class="!hidden md:!flex !z-0 bg-surface overflow-x-auto">
    <soft-menu-outlet name="tab" class="top-tab-menu"></soft-menu-outlet>
  </nav>

  <main
    #main
    [ngClass]="blockScrollY() ? 'overflow-y-hidden' : 'overflow-y-auto'"
    [class]="customClass()"
    class="px-4 overflow-x-hidden"
    cdkScrollable
    [softObserveElementSize]="observeContentSize()"
    (sizeChange)="contentSizeChanged($event)"
  >
    @if (selectedTabTemplate(); as template) {
      <ng-container *ngTemplateOutlet="template"></ng-container>
    }
    <ng-content></ng-content>
  </main>

  <nav class="soft-page-bottom bg-transparent" style="align-self: end">
    @if (bottomContent(); as templateOrComponent) {
      @if (templateOrComponent | instanceof: TemplateRef; as template) {
        <ng-container *ngTemplateOutlet="template"></ng-container>
      } @else {
        <ng-container *ngComponentOutlet="$any(templateOrComponent)"></ng-container>
      }
    }

    <soft-menu-outlet
      name="responsive"
      class="md:!hidden bottom-responsive-menu border-t bg-surface"
    ></soft-menu-outlet>
    <soft-menu-outlet name="page-bottom" class="bottom-menu"></soft-menu-outlet>
    <soft-menu-outlet
      name="tab"
      class="md:!hidden overflow-x-auto bottom-tab-menu bg-surface"
    ></soft-menu-outlet>
  </nav>
</div>
